// src/components/AnimatedBackground.js
import React, { useRef, useEffect } from 'react';
import * as THREE from 'three';

const AnimatedBackground = () => {
  const mountRef = useRef(null);

  useEffect(() => {
    const container = mountRef.current;
    if (!container) return;
    const width = container.clientWidth;
    const height = container.clientHeight;

    // Create scene with white background
    const scene = new THREE.Scene();
    scene.background = new THREE.Color(0xffffff);

    // Set up camera
    const camera = new THREE.PerspectiveCamera(60, width / height, 0.1, 1000);
    camera.position.z = 10;

    // Renderer
    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(width, height);
    container.appendChild(renderer.domElement);

    // Create phone-like objects (wireframe boxes)
    const phoneCount = 30;
    const phones = [];
    const phoneGeometry = new THREE.BoxGeometry(1, 2, 0.1);
    const phoneMaterial = new THREE.MeshBasicMaterial({ color: 0x007BFF, wireframe: true });
    for (let i = 0; i < phoneCount; i++) {
      const phone = new THREE.Mesh(phoneGeometry, phoneMaterial);
      phone.position.x = (Math.random() - 0.5) * 20;
      phone.position.y = (Math.random() - 0.5) * 20;
      phone.position.z = (Math.random() - 0.5) * 20;
      phone.rotation.x = Math.random() * Math.PI;
      phone.rotation.y = Math.random() * Math.PI;
      phone.rotation.z = Math.random() * Math.PI;
      scene.add(phone);
      phones.push(phone);
    }

    // Animation loop: rotate and drift phones upward; reset if too high.
    const animate = () => {
      requestAnimationFrame(animate);
      phones.forEach((phone) => {
        phone.rotation.x += 0.005;
        phone.rotation.y += 0.007;
        phone.position.y += 0.01; // drift upward slowly
        if (phone.position.y > 10) {
          phone.position.y = -10; // reset to bottom when out of view
        }
      });
      renderer.render(scene, camera);
    };
    animate();

    // Handle window resize
    const handleResize = () => {
      const newWidth = container.clientWidth;
      const newHeight = container.clientHeight;
      renderer.setSize(newWidth, newHeight);
      camera.aspect = newWidth / newHeight;
      camera.updateProjectionMatrix();
    };
    window.addEventListener('resize', handleResize);

    // Cleanup on unmount
    return () => {
      window.removeEventListener('resize', handleResize);
      if (container && renderer.domElement && container.contains(renderer.domElement)) {
        container.removeChild(renderer.domElement);
      }
      renderer.dispose();
    };
  }, []);

  return (
    <div
      ref={mountRef}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'block',
      }}
    />
  );
};

export default AnimatedBackground;
